import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Loading from "./components/Loading";

const WhoAreYou = lazy(() => import("./pages/commons/WHOAREYOU"));

const Checkout = lazy(() => import("./components/Checkout"));
const CheckoutSuccess = lazy(() => import("./components/Checkout/Success"));

const sourceParam = new URLSearchParams(window.location.search).get('source');
if (sourceParam) { localStorage.setItem('source', decodeURIComponent(sourceParam)) }
const gclidParam = new URLSearchParams(window.location.search).get('gclid');
if (gclidParam) { localStorage.setItem('gclid', gclidParam); }
const firstVisitedPageParam = new URLSearchParams(window.location.search).get('first_visited_page');
if (firstVisitedPageParam) { localStorage.setItem('first_visited_page', decodeURIComponent(firstVisitedPageParam)); }
const referrerPageParam = new URLSearchParams(window.location.search).get('referrer_page');
if (referrerPageParam) { localStorage.setItem('referrer_page', decodeURIComponent(referrerPageParam)); }

// Récupérer le Client ID de GA4
const getClientIdFromCookie = () => {
  const gaCookie = document.cookie.split(";").find((cookie) => cookie.trim().startsWith("_ga="));
  if (!gaCookie) return null;

  const gaValue = gaCookie.split("=")[1];
  const clientId = gaValue.replace(/^GA\d+\.\d+\./, "");
  return clientId;
};

export default function App() {
  
  // Stocker et envoyer le Client ID de GA4
  useEffect(() => {
    const interval = setInterval(() => {
      const clientId = getClientIdFromCookie();
      if (clientId) {
        localStorage.setItem("cid", clientId);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "initialisation",
          client_id: clientId
        });
        clearInterval(interval);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);
  
  return <Suspense fallback={<Loading />}>
      <BrowserRouter>
        <Routes>
          {/* NOT FOUNDED PAGE OR ROOT PAGE ! */}
          <Route exact path="/" element={<WhoAreYou />} />
          <Route path="*" element={<WhoAreYou />} />

          {/* Réservation */}
          <Route path="/checkout">
            <Route index element={<Checkout />} />
            <Route path="success" element={<CheckoutSuccess />} />
          </Route>

        </Routes>
      </BrowserRouter>
  </Suspense>
}